import {Collapse, Grid} from "@mui/material";
import {useCallback, useState} from "react";
import MhdSelect from "../../atomicComponents/MhdSelect";
import {
  vignetteChoices,
  heliosphericImagersSrcIdChoices,
  scChoicesWithData,
  sliceChoices, mapResolutionChoices
} from "../../../utils/choices";
import MhdInput from "../../atomicComponents/MhdInput";
import WidgetSwitch from "../../atomicComponents/WidgetSwitch";
import MhdColorbarWidget from "../../atomicComponents/MhdColorbarWidget";
import MhdSolidColorWidget from "../../atomicComponents/MhdSolidColorWidget";
import {setAndUpdate, validateAndUpdate} from "../../../utils/helpers";
import MhdWidgetDivider from "../../atomicComponents/MhdWidgetDivider";

const SliceWidget = ({data, mods, warn, errs, update, setter}) => {
  const [customizeStyle, setCustomizeStyle] = useState(false)


  return (
    <Grid container spacing={1}>
      <Grid item xs={6}>
        <WidgetSwitch
            label="Custom View"
            value={data.custom_view}
            onChange={useCallback((v) => setAndUpdate("custom_view", v, setter, update), [])}
          />
      </Grid>
      <Grid item xs={6}>
        <WidgetSwitch
          label="Polarization Brightness"
          value={data.polarized}
          onChange={useCallback((v) => setAndUpdate("polarized", v, setter, update), [])}
        />
      </Grid>
      <Grid item xs={12}>
        <Collapse in={!data.custom_view}>
          <MhdSelect
            label="Instrument"
            value={data.instrument}
            override={mods.instrument}
            warning={warn.instrument}
            error={errs.instrument}
            onChange={useCallback((v) => setAndUpdate("instrument", v, setter, update), [])}
            choices={heliosphericImagersSrcIdChoices}
          />
        </Collapse>
      </Grid>


      <Collapse in={data.custom_view}>
        <Grid container spacing={1} pl={1} pt={1}>
          <Grid item xs={6}>
            <MhdInput
              label='Longitude'
              value={data.longitude}
              override={mods.longitude}
              warning={warn.longitude}
              error={errs.longitude}
              onChange={useCallback((v) => validateAndUpdate("longitude", v, setter, update), [])}
              units='°'
            />
          </Grid>
          <Grid item xs={6}>
            <MhdInput
              label='B Angle'
              value={data.b_angle}
              override={mods.b_angle}
              warning={warn.b_angle}
              error={errs.b_angle}
              onChange={useCallback((v) => validateAndUpdate("b_angle", v, setter, update), [])}
              units='°'
            />
          </Grid>
          <Grid item xs={6}>
            <MhdInput
              label='P Angle'
              value={data.p_angle}
              override={mods.p_angle}
              warning={warn.p_angle}
              error={errs.p_angle}
              onChange={useCallback((v) => validateAndUpdate("p_angle", v, setter, update), [])}
              units='°'
            />
          </Grid>
          <Grid item xs={6}>
            <MhdInput
              label='Radial Distance'
              value={data.r_distance}
              override={mods.r_distance}
              warning={warn.r_distance}
              error={errs.r_distance}
              onChange={useCallback((v) => validateAndUpdate("r_distance", v, setter, update), [])}
              units='AU'
            />
          </Grid>
        </Grid>
      </Collapse>
      <Grid item xs={12}>
        <MhdWidgetDivider
            label="CUSTOMIZE STYLE"
            value={customizeStyle}
            onChange={setCustomizeStyle}
        >
          <Collapse in={customizeStyle} >
            <Grid container spacing={1} pt={"2px"}>
              <Grid item xs={6}>
                <MhdSelect
                  label="Vignette"
                  value={data.vignette_function}
                  onChange={useCallback((v) => setAndUpdate("vignette_function", v, setter, update), [])}
                  choices={vignetteChoices}
                />
              </Grid>
              <Grid item xs={3}>
                <MhdInput
                  label='Radial Power'
                  value={data.radial_power}
                  override={mods.radial_power}
                  warning={warn.radial_power}
                  error={errs.radial_power}
                  onChange={useCallback((v) => validateAndUpdate("radial_power", v, setter, update), [])}
                />
              </Grid>
              <Grid item xs={3}>
                <WidgetSwitch
                  label="Logscale"
                  value={data.log_transform}
                  onChange={useCallback((v) => setAndUpdate("log_transform", v, setter, update), [])}
                />
              </Grid>
              <Grid item xs={4}>
                <WidgetSwitch
                  label="Show Orientation"
                  value={data.show_hpc_orientation}
                  onChange={useCallback((v) => setAndUpdate("show_hpc_orientation", v, setter, update), [])}
                />
              </Grid>
              <Grid item xs={4}>
                <WidgetSwitch
                  label="Show Simulation R0"
                  value={data.show_sim_lower_boundary}
                  onChange={useCallback((v) => setAndUpdate("show_sim_lower_boundary", v, setter, update), [])}
                />
              </Grid>
              <Grid item xs={4}>
                <WidgetSwitch
                  label="Show Simulation R1"
                  value={data.show_sim_upper_boundary}
                  onChange={useCallback((v) => setAndUpdate("show_sim_upper_boundary", v, setter, update), [])}
                />
              </Grid>
              <Grid item xs={12}>
                <MhdSelect
                  label="Map Resolution"
                  value={data.resolution}
                  override={mods.resolution}
                  warning={warn.resolution}
                  error={errs.resolution}
                  onChange={useCallback((v) => setAndUpdate("resolution", v, setter, update), [])}
                  choices={mapResolutionChoices}
                />
              </Grid>
              <Grid item xs={12}>
                <MhdColorbarWidget
                  label="Color Palette"
                  value={data.color}
                  onChange={useCallback((v) => setAndUpdate("color", v, setter, update), [])}
                />
              </Grid>
              <Grid item xs={12}>
                <MhdSolidColorWidget
                  label="Occult Color"
                  value={data.occult_color}
                  onChange={useCallback((v) => setAndUpdate("occult_color", v, setter, update), [])}
                />
              </Grid>
              <Grid item xs={6}>
                <Collapse in={data.custom_view}>
                  <MhdInput
                    label='Inner Occulter'
                    value={data.occult_inner}
                    override={mods.occult_inner}
                    warning={warn.occult_inner}
                    error={errs.occult_inner}
                    onChange={useCallback((v) => validateAndUpdate("occult_inner", v, setter, update), [])}
                    units='°'
                  />
                </Collapse>
              </Grid>
              <Grid item xs={6}>
                <Collapse in={data.custom_view}>
                  <MhdInput
                    label='Outer Occulter'
                    value={data.occult_outer}
                    override={mods.occult_outer}
                    warning={warn.occult_outer}
                    error={errs.occult_outer}
                    onChange={useCallback((v) => validateAndUpdate("occult_outer", v, setter, update), [])}
                    units='°'
                  />
                </Collapse>
              </Grid>
            </Grid>
          </Collapse>
        </MhdWidgetDivider>
      </Grid>
    </Grid>
  );
}

export default SliceWidget;